webpackJsonp([209466549842532],{

/***/ 482:
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"postBySlug": {
				"html": "<p>That's it for the Redux lesson. You now have a fully functional state management system that scales well. It's easy to reason about, and easy to debug.</p>\n<p>It's also a ton of boilerplate. <a href=\"https://gitlab.com/brianegan/flutter_architecture_samples/tree/master/example/redux\">The README of this example gives great insights into what you may not be able to see yet.</a>.</p>\n<p>Particularly:</p>\n<blockquote>\n<p>While this may feel like \"Boilerplate\" when you first start using Redux, the motivation is thus (from the original Redux Docs):</p>\n<p>If a model can update another model, then a view can update a model, which updates another model, and this, in turn, might cause another view to update. At some point, you no longer understand what happens in your app as you have lost control over the when, why, and how of its state. When a system is opaque and non-deterministic, it's hard to reproduce bugs or add new features.</p>\n</blockquote>\n<hr>\n<h3 id=\"next-firebase-auth\"><a href=\"#next-firebase-auth\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Next: Firebase Auth</h3>\n<p>The final part of setting up the not-fun boilerplate of this app is adding Firebase and Firebase Auth.</p>",
				"frontmatter": {
					"title": "Redux Wrap Up"
				},
				"fields": {
					"slug": "/redux-wrap-up"
				}
			}
		},
		"pathContext": {
			"slug": "/redux-wrap-up"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---redux-wrap-up-84542b6caf90eef15756.js